export const SLEEP_MANUAL_TITLES = Object.freeze({
  home: '使用说明',
  start: '第一次使用',
  use: '日常使用',
  faq: '常见问题',
  safety: '安全与清洁',
  service: '参数与售后',
  manual: '完整说明书'
})

export function getSleepManualTopic (section) {
  if (!section) return 'home'
  return Object.prototype.hasOwnProperty.call(SLEEP_MANUAL_TITLES, section) ? section : 'not-found'
}

export function sleepManualLocation (topic = 'home', query = {}) {
  return {
    name: 'SleepManual',
    params: { section: topic === 'home' ? undefined : topic },
    query: { ...query }
  }
}
